module.exports = __webpack_public_path__ + "static/media/Star-icon_actve.57ce2216.svg";